module.exports = __webpack_public_path__ + "3c5b9a411fd6753f534c1eed4c5b4fb7.pdf";